import { fetch } from "../services/api";

const getItems = (roomOccupationId) => {
    console.log('TODO - getItems')
    // return fetch(notificationsByCreatedAt, {
    //     roomOccupationId: roomOccupationId,
    //     sortDirection: 'DESC'
    // }).then(r => {
    //     if (r.data?.NotificationsByCreatedAt?.items) {
    //         const _items = r.data.NotificationsByCreatedAt.items.map(item => { return { ...item, payload: JSON.parse(item.payload) } } )
    //         return _items;
    //     }
    //     throw new Error('user-getNotifications-error')
    // }).catch((response) => {
    //     console.log('error', response)
    // });
}

const getItem = (notificationId) => {
    console.log('TODO - getItem')
    // return fetch(getNotification, {
    //     id: notificationId
    // }).then(r => {
    //     if (r.data?.getNotification?.id) {
    //         const payload = JSON.parse(r.data.getNotification.payload);
    //         if (payload) {
    //             r.data.getNotification.payload = { ...payload }
    //         }
    //         return r.data.getNotification;
    //     }
    //     throw new Error('user-getNotification-error')
    // }).catch((response) => {
    //     console.log('error', response)
    // });
}

const onChangeEvent = (roomOccupationId, cb) => {
    console.log("16ago - events - notificationsActions - onChangeEvent")
    // return fetch(onSomeNotificationRoomOccupationChange, { roomOccupationId: roomOccupationId }).subscribe({
    //     next: (r) => {
    //         if (r.value?.data?.onSomeNotificationRoomOccupationChange) {
    //             cb(r.value.data.onSomeNotificationRoomOccupationChange)
    //         } else {
    //             console.error(r)
    //         }
    //     },
    //     error: (err) => console.error(err)
    // });
}

const markRead = (notificationId) => {
    console.log('notificationId', notificationId)
    console.log('TODO - markRead')
    // return fetch(notificationMarkReadQuery, {
    //     id: notificationId
    // }).then(r => {
    //     if (r.data?.updateNotification?.id) {
    //         return r.data.updateNotification;
    //     }
    //     throw new Error('user-markRead-error')
    // }).catch((response) => {
    //     console.log('error', response)
    // });
}

export {
    getItem,
    getItems,
    markRead,
    onChangeEvent
}